<template>
  <div class="card-container">
    <!-- 人物形象照 -->
    <div class="person-img" v-if="person.bgimage">
      <img :src="person.bgimage" alt="" />
      <div class="arrow"></div>
    </div>

    <!-- 图片上传组件 -->
    <van-uploader
      v-show="false"
      v-model="fileList"
      multiple
      ref="upload"
      accept="image/*"
      :max-count="1"
      :after-read="afterAfter"
    ></van-uploader>

    <div class="main">
      <!-- 上传按钮 -->
      <div class="upload-btn" v-if="canEdit && token" @click="uploadFile">
        添加形象照
      </div>

      <!-- 个人信息区域 -->
      <div class="person-box">
        <img class="about" src="@/assets/card/about.png" alt="" />
        <div class="person">
          <p class="name">{{ person.name }}</p>
          <p class="personOne" v-if="person.empno === '10006588'">Fei Xiong</p>
          <p class="personTwo" v-if="person.empno === '10006588'">
            质量与服务总监
          </p>
          <p class="personThree" v-if="person.empno === '10006588'">
            国家认监委3C认证技术专家组专家
          </p>
          <p class="personThree" v-if="person.empno === '10006588'">
            全国照明电器标准化技术委员会委员
          </p>
          <p class="personThree" v-if="person.empno === '10006588'">
            全国照明电器协会专业技术委员会委员
          </p>
          <p class="personThree" v-if="person.empno === '10006588'">
            中国照明电器协会技术标准委员会委员
          </p>
          <p class="personThree" v-if="person.empno === '10006588'">
            广东省质量管理标准委员会委员
          </p>
          <p class="personThree" v-if="person.empno === '10006588'">
            广东省政府质量奖评审专家
          </p>

          <p class="position mt-2">
            <template v-if="!edit && person.empno !== '10006588'">
              {{ person.position }}
            </template>
            <template v-else>
              <van-field
                v-if="person.empno !== '10006588'"
                v-model="person.position"
                placeholder="请输入职位"
                type="text"
              />
            </template>
          </p>

          <div class="info mt-5">
            <p>
              手机：<a :href="'tel:' + person.mobile">{{ person.mobile }}</a>
            </p>
            <p>
              邮箱：<a :href="'mailto:' + person.email">{{ person.email }}</a>
            </p>
            <p>
              官网：<a target="_blank" href="https://www.nvc-lighting.com.cn/"
                >www.nvc-lighting.com.cn</a
              >
            </p>
            <p class="address">
              地址：
              <template v-if="!edit">
                <span>{{ person.address }}</span>
                <img
                  v-if="canEdit && token"
                  @click="edit = !edit"
                  src="@/assets/card/edit.png"
                  alt=""
                />
              </template>
              <template v-else>
                <van-field
                  v-model="person.address"
                  placeholder="请输入办公地址"
                  type="text"
                />
                <img
                  @click="saveAddress()"
                  src="@/assets/card/save.png"
                  alt=""
                />
              </template>
            </p>
          </div>
        </div>
      </div>

      <!-- 公司logo -->
      <div class="logo">
        <img src="../../assets/LOGOZ.png" alt="" />
      </div>

      <!-- 动态内容部分 -->
      <div
        class="part"
        v-for="(part, index) in partData"
        :key="part.type"
        :class="'part' + (index + 1)"
      >
        <div class="title" :class="{ 'r-title': index % 2 }">
          <p  @blur="part.title1 = $event.target.innerHTML" :contenteditable="isCanEditText"  v-html="part.title1"></p>
          <p @blur="part.title2 = $event.target.innerHTML" :contenteditable="isCanEditText"  v-html="part.title2"></p>
          <p
            @blur="part.subtitle = $event.target.innerHTML"
            class="sname"
            :contenteditable="isCanEditText"
            v-html="part.subtitle"
          ></p>
        </div>
        <div
          class="desc"
          :contenteditable="isCanEditText"
          @blur="part.content = $event.target.innerHTML"
          v-html="part.content"
        ></div>
        <div class="banner wow zoomIn">
          <div :class="'swiper-container part' + (index + 1) + '-container'">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(img, imgIndex) in localImages"
                :key="imgIndex"
              >
                <div
                  class="img-box"
                  :style="{ backgroundImage: 'url(' + img + ')' }"
                >
                  <img class="banner-img" :src="img" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 二维码 -->
      <div class="qrcode">
        <img src="@/assets/card/qrcode.png" alt="" />
      </div>
    </div>
    <div class="edit-btn" @click="toggleEditMode" v-if="hasEditTextPerm">
      {{ isCanEditText ? "确定" : "编辑" }}
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import api from "@/apis";
import utils from "@/utils/utils";
import wx from "weixin-js-sdk";
import { getToken } from "@/utils/cookie";

export default {
  data() {
    return {
      empNo:"",
      isWxWork: utils.parseUA().wxWork,
      edit: false,
      canEdit: false,
      workcode: this.$route.query.workcode,
      person: {},
      fileList: [],
      token: "",
      localImages: [
        [
          require("@/assets/card/b1.png"),
          require("@/assets/card/l1.jpg"),
          require("@/assets/card/l2.jpg"),
          require("@/assets/card/l3.jpg"),
          require("@/assets/card/l4.jpg"),
          require("@/assets/card/a1.jpg"),
        ],
        [
          require("@/assets/card/h7.png"),
          require("@/assets/card/h8.png"),
          require("@/assets/card/h9.png"),
          require("@/assets/card/h10.png"),
        ],
        [
          require("@/assets/card/b5.jpg"),
          require("@/assets/card/b6.jpg"),
          require("@/assets/card/b7.jpg"),
          require("@/assets/card/b8.jpg"),
        ],
        [
          require("@/assets/card/g1.jpg"),
          require("@/assets/card/g2.png"),
          require("@/assets/card/g3.jpg"),
          require("@/assets/card/g4.png"),
          require("@/assets/card/g5.jpg"),
        ],
      ],
      partData: [
        {
          type: 1,
          title1: "用照明科技",
          title2: "改变生活",
          subtitle: "LIGHT ENEVIRONMENT EXPERT",
          content:
            "雷士照明创立于1998年，是一家集品牌、研发、设计、生产、营销、服务于一体的全产业链照明品牌企业。品牌价值达679.85亿元，十六年蝉联中国照明行业榜首；并上榜亚洲品牌500强，位列353位，是唯一连续五年入选的照明品牌。2022年赢得中国航天精工认可，成为行业独家'中国航天事业合作伙伴'。全国拥有34个运营中心、116家全屋光环境智能体验馆、2400多家品牌专卖店和近100000家销售终端网点，旗下布局全屋照明、酒店照明、商业照明、公共照明、特种照明五⼤业务⼦品牌，以健康化、智能化、⼈性化的照明科技，为⽤⼾提供⾼品质的照明产品和多场景照明应⽤解决⽅案。",
        },
        {
          type: 2,
          title1: "坚持自主创新",
          title2: "健康光环境专家",
          subtitle:
            "ADHERE TO INDEPENDENT INNOVATION<br>HEALTH LIGHT ENVIRONMENT EXPERT",
          content:
            "雷士照明拥有国际标准化的照明研发中心和CNAS认可实验室，与中国航天科研机构共建行业首个'中国航天照明科技实验室'，研发航天级健康照明科技——伴生适然光技术，开创健康光时代。参与多项国家课题研究，参与制（修）订的国家及行业标准超170项，专利超2000项，先后获科学技术进步奖、科技创新一等奖、中国国际照明灯具设计大赛一等奖等尖端科技、产品奖项超30项。以⼀站式专业智能照明解决⽅案打造健康光⽣态。",
        },
        {
          type: 3,
          title1: "以品质之光",
          title2: "点亮国家地标",
          subtitle: "WITH THE LIGHT OF QUALITY<br>LIGHTING NATIONAL LANDMARKS",
          content:
            "雷⼠照明是为数不多的全产业线灯具制造商，产品覆盖地产、⼾外、公共⼤空间、办公、医院、商超、酒店、店铺、餐饮、⼯业、教育、智能消防等照明领域，以品质之光，成功助⼒点亮杭州亚运会、中国西昌航天城、北京奥运会、北京冬奥会、北京世园会等国家众多地标项⽬，获新华社、⼈⺠⽇报等央媒集体点赞。",
        },
        {
          type: 4,
          title1: "勇担⺠族责任",
          title2: "创国品之光",
          subtitle:
            "SHOULDER NATIONAL RESPONSIBILITIES BRAVELY<br>LIGHT OF NATIONAL PRODUCTS",
          content:
            "⺠族品牌服务⼈⺠，雷⼠照明'拾光计划'公益活动，已走遍全国31个省市，持续改善220多所学校照明环境，13万多名师⽣获益；积极参与国家抗疫⾏动，第⼀时间援建雷神⼭、⽕神⼭医院，勇担社会责任。",
        },
      ],
      isCanEditText: false, //是否可以编辑文本内容
      hasEditTextPerm:false,//是否有编辑文本内容的按钮权限
    };
  },
  created() {
    this.token = getToken();
    this.canEdit = this.token;
    if (this.token) {
      this.empNo = this.token;
    }
    this.getUserinfo();
    this.getConfigText();
    this.sendAuth();
  },
  mounted() {
    this.initBnaner();
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
    this.$forceUpdate();
  },
  methods: {
    sendAuth() {
      api.getSelectPermission({ empNo: this.empNo }).then((data) => {
        const perData = data.data;
        // 是否有编辑文本权限按钮
       this.hasEditTextPerm = perData.some((item=>{
          return item.permission==10;  //电子名片 有这个权限就会有编辑按钮
        }))
      });
    },
    toggleEditMode() {
      if (this.isCanEditText) {
        this.isCanEditText = false;
        console.log(this.partData,'partData');
        
        api.editEnterprise(this.partData).then((res) => {
          if (res.msg == 'success') {
            this.$toast("修改成功");
            this.getConfigText();
          }
        });
      } else {
        this.$toast("双击文本区域进行修改");
        this.isCanEditText = true;
      }
    },
    // 获取默认展示数据
    getConfigText() {
      api.queryEnterprise().then((res) => {
        const {data}=res;
        if(data.length!=0){
          this.partData = data 
        }
      });
    },
    getConfigdata() {
      let _this = this;
      let data = {
        url: encodeURIComponent(
          "http://qw.nvc-lighting.com.cn:8088/mobile/card?workcode=" +
            this.person.empno
        ),
        jsApiList:
          "updateAppMessageShareData,updateTimelineShareData,onMenuShareAppMessage,onMenuShareWechat,onMenuShareTimeline",
      };
      if (this.isWxWork) {
        data.appid = 1;
        data.jsApiList =
          "onMenuShareAppMessage,onMenuShareWechat,onMenuShareTimeline,shareAppMessage,shareWechatMessage";
      }
      api.getConfigdata(data).then((res) => {
        let wxData = res.data;
        if (this.isWxWork) {
          wx.config({
            beta: true,
            debug: false,
            appId: wxData.appId,
            timestamp: "" + wxData.timestamp,
            nonceStr: wxData.nonceStr,
            signature: wxData.signature,
            jsApiList: JSON.parse(wxData.jsApiList),
          });
          wx.ready(function () {
            wx.onMenuShareAppMessage({
              title: _this.person.name,
              link: wxData.url,
              desc: _this.person.position,
              imgUrl:
                "http://qwapp.nvc-lighting.com:1109/nvc/public/uploads/card/nvc.png",
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              },
            });
            wx.onMenuShareTimeline({
              title: _this.person.name,
              link: wxData.url,
              desc: _this.person.position,
              imgUrl:
                "http://qwapp.nvc-lighting.com:1109/nvc/public/uploads/card/nvc.png",
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              },
            });
          });
        } else {
          wx.config({
            debug: false,
            appId: wxData.appId,
            timestamp: "" + wxData.timestamp,
            nonceStr: wxData.nonceStr,
            signature: wxData.signature,
            jsApiList: JSON.parse(wxData.jsApiList),
          });
          wx.ready(function () {
            wx.updateAppMessageShareData({
              title: _this.person.name,
              link: wxData.url,
              desc: _this.person.position,
              imgUrl:
                "http://qwapp.nvc-lighting.com:1109/nvc/public/uploads/card/nvc.png",
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              },
            });
            wx.updateTimelineShareData({
              title: _this.person.name,
              link: wxData.url,
              imgUrl:
                "http://qwapp.nvc-lighting.com:1109/nvc/public/uploads/card/nvc.png",
              desc: _this.person.position,
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              },
            });
          });
        }
      });
    },
    uploadFile() {
      if (!this.canEdit) return;
      this.$refs.upload.chooseFile();
    },
    afterAfter(e) {
      let formData = new FormData();
      formData.append("b068931cc450442b63f5b3d276ea4297", e.file);
      api.cardUpload(formData).then((res) => {
        this.person.bgimage = res.data.url;
      });
    },
    saveAddress() {
      let data = {
        address: this.person.address,
        position: this.person.position,
      };
      api.cardUpdateInfo(data).then((res) => {
        if (res.code == 1) {
          this.$notify({
            type: "success",
            message: "修改成功",
          });
          this.edit = false;
        }
      });
    },
    getUserinfo() {
      api.getCardUserinfo({ workcode: this.workcode }).then((res) => {
        this.person = res.data;
        if (!this.workcode)
          this.$router.push({
            name: "card",
            query: {
              workcode: this.person.empno,
            },
          });
        this.getConfigdata();
      });
    },
    initBnaner() {
      this.partData.forEach((part, index) => {
        new Swiper(`.part${index + 1}-container`, {
          autoplay: { delay: 3000 },
          effect: index % 2 ? "fade" : "slide",
          loop: true,
          nextButton: ".swiper-button-next",
          prevButton: ".swiper-button-prev",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020/375;

@mixin flex-center($way: row) {
  display: flex;
  flex-direction: $way;
  align-items: center;
  justify-content: center;
}

@mixin flex-start($way: row) {
  display: flex;
  flex-direction: $way;
  justify-content: flex-start;
}

@keyframes breathe {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes pullup {
  0% {
    top: 620px;
    opacity: 1;
  }
  100% {
    top: 600px;
    opacity: 0;
  }
}

@media screen and (max-width: 600px) {
  .card-container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .card-container {
    width: 420px * $zoom;
  }
}

.card-container {
  background: #ffffff;

  .person-img {
    position: fixed;
    z-index: 1;
    width: 10rem;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100%;

    & > img {
      width: 100%;
    }

    .arrow {
      width: 80px;
      height: 40px;
      background: url("~@/assets/card/arrow.png") 0 0 no-repeat;
      background-size: 100% 100%;
      position: absolute;
      z-index: 2;
      left: 50%;
      margin-left: -25px;
      margin-top: -28px;
      top: 640px;
      -webkit-animation-name: pullup;
      -webkit-animation-duration: 2s;
      -webkit-animation-iteration-count: infinite;
      animation-name: pullup;
      animation-duration: 2s;
      animation-iteration-count: infinite;
    }
  }

  .main {
    padding-top: 100%;
    position: relative;
    z-index: 2;

    & > .upload-btn {
      background: rgba($color: #eeeeee, $alpha: 0.8);
      text-align: center;
      line-height: 60px;
      font-size: 20px;
      cursor: pointer;
      color: #4a4848;
    }

    & > div {
      background-color: #ffffff;
    }

    .person-box {
      background: #f3fffb;
      position: relative;

      .personOne {
        font-size: 30px;
        margin: 10px 0 20px 0;
      }

      .personTwo {
        font-weight: bold;
        margin-bottom: 20px;
      }

      .personThree {
        font-size: 30px;
        margin-bottom: 10px;
        color: #4a4848;
      }

      .about {
        position: absolute;
        top: 0;
        right: 0;
        width: 190px;
        z-index: 3;
      }

      & > .person {
        position: relative;
        z-index: 2;
        padding-top: 120px;
        padding-bottom: 120px;
        padding-left: 100px;
        padding-right: 100px;
        background: url("~@/assets/card/2.png") no-repeat;
        background-size: 100% auto;
        background-position: center center;

        .name {
          font-size: 78px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #129460;
        }

        .sname {
          font-size: 24px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #4a4848;
        }

        .position {
          font-size: 36px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #4f4c4d;
        }

        .info {
          & > p {
            font-size: 22px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: #4f4c4d;
            padding-left: 40px;
            background-image: url("~@/assets/card/phone.png");
            background-repeat: no-repeat;
            background-size: 25px auto;
            background-position: left center;

            & > a {
              color: #4f4c4d;
            }

            &:nth-child(2) {
              background-image: url("~@/assets/card/img.png");
            }
            &:nth-child(3) {
              background-image: url("~@/assets/card/pc.png");
            }
            &:nth-child(4) {
              background-image: url("~@/assets/card/address.png");
            }
          }

          & > p:not(:last-child) {
            margin-bottom: 20px;
          }

          & > .address {
            @include flex-start();
            align-items: center;

            &::v-deep .van-field {
              width: 300px;
              padding: 6px 8px;

              .van-field__control {
                font-size: 22px;
                font-family: PingFang SC;
                color: #7c808c;
              }
            }

            & > img {
              width: 24px;
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .logo {
    @include flex-center();
    padding: 10px 0;

    & > img {
      width: 550px;
    }
  }

  .part {
    background-image: url("~@/assets/card/6.png");
    background-repeat: no-repeat;
    background-size: 100% auto;

    .title {
      padding: 70px 70px 40px;

      & > p {
        font-size: 50px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #129460;
      }

      & > .sname {
        margin-top: 10px;
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #129460;
      }
    }

    .r-title {
      text-align: right;
    }

    .desc {
      padding: 40px 70px;
      font-size: 24px;
      font-family: Source Han Sans SC;
      font-weight: 300;
      color: #4f4c4d;
      line-height: 36px;
      text-align: justify;

      & > span {
        font-weight: bold;
      }
    }

    .banner {
      padding: 0 70px;

      .swiper-button-next,
      .swiper-container-rtl .swiper-button-prev {
        background: url("~@/assets/company/next1.png") no-repeat;
        background-size: 100% 100%;
        width: 16px;
        height: 30px;
      }

      .swiper-button-prev,
      .swiper-container-rtl .swiper-button-next {
        background: url("~@/assets/company/prev1.png") no-repeat;
        background-size: 100% 100%;
        width: 16px;
        height: 30px;
      }

      .img-box {
        overflow: hidden;
        margin: 0 auto;
        background-size: cover;
        background-position: center center;
        font-size: 0;

        img {
          width: 100%;
          height: 300px;
          opacity: 0;
        }
      }
    }
  }

  .part1 {
    .title {
      padding: 110px 70px 40px;
    }
  }

  .part2 {
    background-image: url("~@/assets/card/7.png");

    .title {
      padding: 80px 60px 40px;
    }
  }

  .part3 {
    background-image: url("~@/assets/card/8.png");
  }
  .part4 {
    background-image: url("~@/assets/card/9.png");
  }

  .qrcode {
    background: url("~@/assets/card/10.png") no-repeat;
    background-position: right top;
    background-size: 610px auto;
    padding: 110px 0 50px;

    & > img {
      width: 240px;
      display: block;
      margin: 0 auto;
    }
  }

  .edit-btn {
    font-size: 24px;
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 2;
    width: 80px;
    height: 80px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.5);
      transform: scale(1.1);
    }
  }
}
</style>
